import React from 'react'
import { DumbField } from '../Field'
import { RadioInput, Select } from './Form'
import MultiComplete from './MultiComplete'

const DEFAULT_OPTION = {value: '', label: '[Select a year]'}

export default class EFSCropPicker extends React.Component {
  setByKey = (value, key) => {
    this.props.onChange({ ...this.props.value, [key]: value })
  }
  generateAllYears = (startYear, endYear) => {
    let years = []
    for (let step=startYear; step <= endYear; ++step) {
      years.push({
        value: step,
        label: step.toString()
      })
    }
    return years
  }
  startYear = 1970
  currentYear = new Date().getFullYear()
  endYear = this.currentYear + 100
  allYears = this.generateAllYears(this.startYear, this.endYear)
  getStartYearOptions = () => {
    const { endYear } = this.props.value
    if (endYear) {
      const stringYear = endYear.toString()
      const yearIndex = this.allYears.findIndex(y => y.label == stringYear)
      return this.allYears.slice(0, yearIndex)
    }
    return this.allYears
  }
  getEndYearOptions = () => {
    const { startYear } = this.props.value
    if (startYear) {
      const stringYear = startYear.toString()
      const yearIndex = this.allYears.findIndex(y => y.label == stringYear)
      return this.allYears.slice(yearIndex + 1)
    }
    return this.allYears
  }
  render() {
    const { fieldId, value, required, disabled, label } = this.props
    return (
      <div className='efs-crop-picker'>
        <DumbField fieldId={`${fieldId}-radio`} label={label} ownsLabel required={required}>
          <RadioInput
            label={label}
            ownsLabel
            disabled={disabled}
            value={value.yearType}
            onChange={value => this.setByKey(value, 'yearType')}
            required={required}
            options={[
              { value: 'AllYears', label: 'All Years' },
              { value: 'LienDuration', label: process.env.EFS_CROP_PICKER_NONE_LABEL || 'None' },
              { value: 'YearDuration', label: 'Specified Year Through Duration' },
              { value: 'Arbitrary', label: 'Specified Years' }
            ]}
          />
        </DumbField>
        {value.yearType === 'YearDuration' && (
          <div className="flex-row">
            <div className="col-sm-6 col-md-4 col-lg-3">
              <DumbField label="Starting year" fieldId={`${fieldId}-start`} required={required}>
                <Select
                  disabled={disabled}
                  options={[DEFAULT_OPTION, ...this.getStartYearOptions()]}
                  value={value.startYear}
                  onChange={value => this.setByKey(value, 'startYear')}
                />
              </DumbField>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-3">
              <DumbField label="Ending year" fieldId={`${fieldId}-end`} required={required}>
                <Select
                  disabled={disabled}
                  options={[DEFAULT_OPTION, ...this.getEndYearOptions()]}
                  value={value.endYear}
                  onChange={value => this.setByKey(value, 'endYear')}
                />
              </DumbField>
            </div>
          </div>
        )}
        {value.yearType === 'Arbitrary' && (
          <DumbField>
            <MultiComplete
              required={required}
              disabled={disabled}
              fieldId={`${fieldId}-arbitrary`}
              label="Select years"
              value={value.years}
              onChange={value => this.setByKey(value, 'years')}
              options={this.allYears}
            />
          </DumbField>
        )}
      </div>
    )
  }
}
